
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { default as Model } from '../../models/postCategories.model';
import SubmitButton from '../../components/ui/SubmitButton.vue';
import FileUpload from '../../components/ui/FileUpload.vue';
import swal from '../../helper/swal.helper';

export default defineComponent({
  components: {
    SubmitButton,
    FileUpload,
  },
  setup() {
    const router = useRouter();
    let status = ref(true);
    let isSubmitting = ref(false);
    let categoryName = ref('');
    let orderNumber = ref();
    let thumbnailFile = ref<any>(null);

    async function submitForm() {
      isSubmitting.value = true;
      let category = {
        name: categoryName.value,
        status: status.value,
        order_number: orderNumber.value,
        thumbnail: await thumbnailFile.value?.uploadImage(),
      };

      let addResult = await Model.create(category);
      if (addResult.status) {
        router.push('/post-categories');
        isSubmitting.value = false;
      } else {
        swal.alert(addResult.message);
        isSubmitting.value = false;
      }
    }

    return {
      submitForm,
      categoryName,
      status,
      isSubmitting,
      thumbnailFile,
      orderNumber,
    };
  },
});
